<template>
  <v-container class="top-spacer">
    <div class="component-title">Base de Dados</div>
    <v-row>
      <v-col cols="12">
        <!-- TABS -->
        <v-row>
          <v-col>
            <v-tabs v-model="tab">
              <v-tab>Modalidades</v-tab>
              <v-tab>Países</v-tab>
              <v-tab>Competições</v-tab>
              <v-tab>Jogador / Equipa</v-tab>
              <v-tab>Mercados</v-tab>
            </v-tabs>
          </v-col>
        </v-row>
        <!-- TAB ITEMS -->
        <v-row>
          <v-col>
            <v-tabs-items v-model="tab" style="width: 100%;">
              <!-- Modalidades -->
              <v-tab-item>
                <SportsTable></SportsTable>
              </v-tab-item>
              <!-- Paises -->
              <v-tab-item><CountriesTable></CountriesTable></v-tab-item>
              <!-- Competições -->
              <v-tab-item><CompetitionsTable></CompetitionsTable></v-tab-item>
              <!-- Jogador / Equipa -->
              <v-tab-item><TeamsTable></TeamsTable></v-tab-item>
              <!-- Mercados -->
              <v-tab-item><MarketsTable></MarketsTable></v-tab-item>
            </v-tabs-items>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<style scoped>

</style>

<script>
import SportsTable from "@/components/backoffice/SportsTable.vue";
import CountriesTable from "@/components/backoffice/CountriesTable.vue";
import CompetitionsTable from "@/components/backoffice/CompetitionsTable.vue";
import TeamsTable from "@/components/backoffice/TeamsTable.vue";
import MarketsTable from "@/components/backoffice/MarketsTable.vue";

export default {
  name: "BackofficeBaseDados",
  components: {
    SportsTable,
    CountriesTable,
    CompetitionsTable,
    TeamsTable,
    MarketsTable
  },
  data: () => ({
    tab: null,
  })
};
</script>
